/*
 * پیش‌نمایش زنده‌ی گزارش — آینه‌ی `api/report_templates/render.py`.
 *
 * چرا دو پیاده‌سازی: ادیتور باید همان لحظه‌ای که کشویی را عوض می‌کند ببیند
 * روی کاغذ چه می‌شود، و رفت‌وبرگشت با سرور برای هر کلید فشرده‌شده کند است.
 *
 * **آنچه چاپ می‌شود همیشه متنِ سرور است، نه این.** هر بار که ذخیره انجام
 * می‌شود، `rendered_text` سرور جای این پیش‌نمایش را می‌گیرد. پس اگر روزی این
 * دو از هم فاصله بگیرند، ادیتور بلافاصله در همان صفحه می‌بیند و هیچ‌وقت
 * گزارشِ اشتباهی چاپ نمی‌شود. اگر منطق آن‌طرف عوض شد، اینجا را هم عوض کنید.
 */

const PLACEHOLDERS = new Set(['Choose an item.', 'Choose the Bone Type. ']);

/** مقدار خالی، جای‌نگهدار، یا گزینه‌های فقط-فاصله‌ی فایل ورد. */
export function isBlank(value) {
  if (value === null || value === undefined) return true;
  if (PLACEHOLDERS.has(value)) return true;
  return String(value).replace(/^[ .]+|[ .]+$/g, '') === '';
}

function segmentText(segment, values) {
  if (segment.kind === 'static') return segment.text;
  const value = values[segment.key];
  if (segment.kind === 'select') return isBlank(value) ? '' : String(value);
  if (segment.kind === 'text') return value ? String(value).trim() : '';
  return '';
}

/**
 * یک سطر. اگر همه‌ی ورودی‌هایش خالی باشند اصلاً نمی‌آید — وگرنه یک
 * «Bone type:» تنها روی کاغذ می‌ماند.
 */
function renderLine(segments, values) {
  const inputs = segments.filter((s) => s.kind !== 'static');
  if (inputs.length && inputs.every((s) => isBlank(values[s.key]))) return '';
  return segments.map((s) => segmentText(s, values)).join('').replace(/\s+$/, '');
}

export function renderReport(template, data) {
  if (!template) return '';
  const values = data || {};
  const lines = [];

  template.blocks.forEach((block) => {
    if (block.type === 'paragraph') {
      lines.push(block.text);
    } else if (block.type === 'spacer') {
      lines.push('');
    } else if (block.type === 'line') {
      const line = renderLine(block.segments, values);
      if (line) lines.push(line);
    } else if (block.type === 'rows') {
      const indent = block.indent || '';
      (values[block.key] || []).forEach((row) => {
        const line = renderLine(block.segments, row || {});
        if (line) lines.push(indent + line);
      });
    } else if (block.type === 'signature') {
      lines.push('');
      lines.push(block.closing);
      lines.push(block.name);
    }
  });

  const cleaned = [];
  lines.forEach((line) => {
    if (!line && (!cleaned.length || !cleaned[cleaned.length - 1])) return;
    cleaned.push(line);
  });
  while (cleaned.length && !cleaned[cleaned.length - 1]) cleaned.pop();

  return cleaned.join('\n');
}

/** داده‌ی خالیِ یک گزارش تازه، با همان تعداد ردیفی که قالب می‌گوید. */
export function blankReportData(template) {
  const data = {};
  if (!template) return data;

  template.blocks.forEach((block) => {
    if (block.type === 'line') {
      block.segments.forEach((segment) => {
        if (segment.kind !== 'static') data[segment.key] = '';
      });
    } else if (block.type === 'rows') {
      data[block.key] = Array.from({ length: block.initial_rows || 1 }, () =>
        blankRow(block)
      );
    }
  });
  return data;
}

export function blankRow(block) {
  const row = {};
  block.segments.forEach((segment) => {
    if (segment.kind !== 'static') row[segment.key] = '';
  });
  return row;
}
